export default {
  title: 'You can continue your booking',
  text: 'Either you have a booking now or you just had. You have the opportunity to play on {0} for half an hour more.',
  submitButton: 'Continue your booking'
}